module.exports = __webpack_public_path__ + "img/case2.ca049f5b.jpg";